import { HEADER_FAIRE_TIMEZONE } from "@faire/web--source/common/consts/HEADER_FAIRE_TIMEZONE";

import { headerInterceptorFactory } from "./headerInterceptor";

export const timezoneHeaderInterceptor = headerInterceptorFactory({
  header: HEADER_FAIRE_TIMEZONE,
  value: () => Intl.DateTimeFormat().resolvedOptions().timeZone,
});
